export const DATAHUB_API = window.appSettings.Api.CommonApiUrl;
export const SPA_HOSTING_API = window.appSettings.Api.SpaApiUrl;
